import React from 'react';
import Image from 'next/legacy/image';
import { t, translate } from 'react-switch-lang';

import { ExternalLink } from '../Link';
import { events } from '../../utils/Amplitude';
import style from '../../styles/AuthForm.module.scss';
import buttonStyle from '../../styles/Button.module.scss';

function AuthPageSkeleton({ children }) {
  return (
    <div className={`${style.authPageContainer} maxWidth16`}>
      <div className={style.authFormContainer}>
        <div className={style.authForm}>
          {children}
        </div>
      </div>
      <div className={style.authContentContainer}>
        <div className={style.heroGraphic}>
          <Image
            src="/assets/HeroGraphic.png"
            alt=""
            height={0}
            width={0}
            layout="responsive"
            objectFit="contain"
            unoptimized
            priority
          />
        </div>

        <h1
          className={style.headingTitle}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: t('LoginRegister_Title') }}
        />
        <p
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: t('LoginRegister_SubTitle') }}
        />
        <ExternalLink
          href={t('Link_PaySimply_Partner_Portal_PaysimplyServices')}
          text={t('LoginRegister_SubTitle_LearnMore_Link')}
          aria-label={t('LoginRegister_SubTitleLinkDescription')}
          ampEvent={events.USER_CLICKED_PAYSIMPLY_SERVICES_LINK}
          className={`${buttonStyle.btn} ${buttonStyle.outline} mt-2`}
        />
      </div>
    </div>
  );
}

export default translate(AuthPageSkeleton);
